<template>
  <div class="delModel" v-if="isShow">
    <div class="model-dissolve">
      <p class="head">修改组名</p>
      <div class="box">
        <p class="label">名称</p>
        <input type="text" v-model.trim="groupName" class="danmu-txt" clearable />
      </div>
      <div class="dissolve-box">
        <div class="btnclose" @click="handleClose">{{ dialogCloseBtnTitle }}</div>
        <div class="btn0k" @click="handleSave">{{  dialogOkBtnTitle }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dialogOkBtnTitle: {
      type: String,
      default: '确定'
    },
    dialogCloseBtnTitle: {
      type: String,
      default: '取消'
    }
  },
  data () {
    return {
      groupName: '',
      isShow: false,
      item: {}
    }
  },
  methods: {
    init(acc) {
      console.log('🚀 ~ init ~ acc:', acc)
      this.groupName = acc.groupName
      this.item = acc
      this.isShow = !this.isShow
    },
    handleReset() {
      this.isShow = !this.isShow
      this.groupName = ''
    },
    handleClose() {
      this.isShow = false
      this.$emit('handleEditClose')
    },
    handleSave() {
      if (!this.groupName.length) return this.$toast('分组名称必填！')
      this.$emit('handleEditSave', {id: this.item.userId, groupName: this.groupName})
    }
  }
}
</script>

<style lang="less" scoped>
 .delModel {
    position: fixed;
    z-index: 9999;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 26px;

    .model-dissolve {
      position: absolute;
      left: 50%;
      top: 50%;
      margin-left: -160px;
      margin-top: -98px;
      background: url("../../../assets/images/grade/dissolve-bg.png") no-repeat
        center center / 100% 100%;
      width: 320px;
      height: 195px;
      padding: 15px 17px 16px;
      box-sizing: border-box;

      .head {
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 600;
        font-size: 17px;
        color: #000000;
        line-height: 20px;
        margin-bottom: 20px;
        text-align: center;
      }
      .box{
        display: flex;
        align-items: center;
        margin-bottom: 30px;
        .label{
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 400;
          font-size: 16px;
          color: rgba(0,0,0,0.8);
          margin-right: 10px;
        }
        .danmu-txt{
          flex: 1;
          // width: 247px;
          height: 40px;
          background: #FFFFFF;
          padding: 0 6px;
          border-radius: 4px;
          border: 1px solid rgba(0,0,0,0.2);
        }
      }

      .title {
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        font-size: 16px;
        color: rgba(0, 0, 0, 0.8);
        line-height: 21px;
        margin: 0 16px;
        text-align: center;
      }
      .h60{
        height: 60px;
      }

      .dissolve-box {
        margin-top: 16px;
        display: flex;
        align-items: center;

        .btnclose {
          flex: 1;
          height: 42px;
          background: rgba(0, 0, 0, 0.08);
          border-radius: 20px;
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 400;
          font-size: 16px;
          color: #7a8494;
          line-height: 42px;
          text-align: center;
        }

        .btn0k {
          margin-left: 27px;
          flex: 1;
          height: 42px;
          background: #EB1700;
          box-shadow: 0px 2px 4px 0px rgba(255, 91, 12, 0.25);
          border-radius: 22px;
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 400;
          font-size: 16px;
          color: #ffffff;
          line-height: 42px;
          text-align: center;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/grade/components/modelEdit.vue